//LoginRoutes.js

import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const Login = lazy(() => import("../pages/auth/Login"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const VerifyOtp = lazy(() => import("../pages/auth/VerifyOtp"));
const SignupMobile = lazy(() => import("../pages/auth/signup/SignupMobile"));
const SignupOtp = lazy(() => import("../pages/auth/signup/SignupOtp"));
const SignupAadhaar = lazy(() => import("../pages/auth/signup/SignupAadhaar"));
const SignupAadhaarOtp = lazy(() => import("../pages/auth/signup/SignupAadhaarOtp"));
const SignupAadhaarUpload = lazy(() => import("../pages/auth/signup/SignupAadhaarUpload"));
const SignupPan = lazy(() => import("../pages/auth/signup/SignupPan"));
const SignupPanUpload = lazy(() => import("../pages/auth/signup/SignupPanUpload"));
const SignupBusinessDetails = lazy(() => import("../pages/auth/signup/SignupBusinessDetails"));
const SignupBusinessDocuments = lazy(() => import("../pages/auth/signup/SignupBusinessDocuments"));
const SignupSuccess = lazy(() => import("../pages/auth/signup/SignupSuccess"));
const CustomerLanding = lazy(() => import("../pages/modules/Customer/HomePage"));
const AboutPage = lazy(() => import("../pages/modules/Customer/AboutPage"));
const TermsPage = lazy(() => import("../pages/modules/Customer/TermsPage"));
const PrivacyPage = lazy(() => import("../pages/modules/Customer/PrivacyPage"));
const RefundPage = lazy(() => import("../pages/modules/Customer/RefundPage"));
const ContactPage = lazy(() => import("../pages/modules/Customer/ContactPage"));
const CustomerLoginPage = lazy(() => import("../pages/modules/Customer/LoginPage"));
const CustomerProfilePage = lazy(() => import("../pages/modules/Customer/ProfilePage"));
const CustomerOrdersPage = lazy(() => import("../pages/modules/Customer/OrdersPage"));
const OrderReceiptPage = lazy(() => import("../pages/modules/Customer/OrderReceiptPage"));
const CustomerAddressesPage = lazy(() => import("../pages/modules/Customer/AddressesPage"));
const PaymentResponsePage = lazy(() => import("../pages/modules/Customer/PaymentResponsePage"));
const LocationPage = lazy(() => import("../pages/modules/Customer/LocationPage"));

const RouteFallback = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>
  </div>
);


const LoginRoutes = () => {
    return (
        <>
            <Suspense fallback={<RouteFallback />}>
                <Routes>
                    {/* Payment Response - Must be first to avoid conflicts */}
                    <Route
                        path="/payment-response"
                        element={
                            <PaymentResponsePage />
                        }
                    />
                    <Route
                        path="/customer/payment-response"
                        element={
                            <PaymentResponsePage />
                        }
                    />
                    <Route
                        path="/"
                        element={
                            <Login />
                        }
                    />
                    <Route
                        path="/menu"
                        element={
                            <CustomerLanding />
                        }
                    />
                    <Route
                        path="/about"
                        element={
                            <AboutPage />
                        }
                    />
                    <Route
                        path="/terms"
                        element={
                            <TermsPage />
                        }
                    />
                    <Route
                        path="/privacy"
                        element={
                            <PrivacyPage />
                        }
                    />
                    <Route
                        path="/refund"
                        element={
                            <RefundPage />
                        }
                    />
                    <Route
                        path="/contact"
                        element={
                            <ContactPage />
                        }
                    />
                    <Route
                        path="/login"
                        element={
                            <CustomerLoginPage />
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <CustomerProfilePage />
                        }
                    />
                    <Route
                        path="/orders"
                        element={
                            <CustomerOrdersPage />
                        }
                    />
                    <Route
                        path="/orders/:id"
                        element={
                            <OrderReceiptPage />
                        }
                    />
                    <Route
                        path="/addresses"
                        element={
                            <CustomerAddressesPage />
                        }
                    />
                    <Route
                        path="/location"
                        element={
                            <LocationPage />
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <Login />
                        }
                    />
                    <Route
                        path="/forgot-password"
                        element={
                            <ForgotPassword />
                        }
                    />
                    <Route
                        path="/reset-password"
                        element={
                            <ResetPassword />
                        }
                    />
                    <Route
                        path="/verify-otp"
                        element={
                            <VerifyOtp />
                        }
                    />
                    <Route
                        path="/signup"
                        element={
                            <SignupMobile />
                        }
                    />
                    <Route
                        path="/signup/otp"
                        element={
                            <SignupOtp />
                        }
                    />
                    <Route
                        path="/signup/aadhaar"
                        element={
                            <SignupAadhaar />
                        }
                    />
                    <Route
                        path="/signup/aadhaar-otp"
                        element={
                            <SignupAadhaarOtp />
                        }
                    />
                    <Route
                        path="/signup/aadhaar-upload"
                        element={
                            <SignupAadhaarUpload />
                        }
                    />
                    <Route
                        path="/signup/pan"
                        element={
                            <SignupPan />
                        }
                    />
                    <Route
                        path="/signup/pan-upload"
                        element={
                            <SignupPanUpload />
                        }
                    />
                    <Route
                        path="/signup/business-details"
                        element={
                            <SignupBusinessDetails />
                        }
                    />
                    <Route
                        path="/signup/business-documents"
                        element={
                            <SignupBusinessDocuments />
                        }
                    />
                    <Route
                        path="/signup/success"
                        element={
                            <SignupSuccess />
                        }
                    />
                    {/* Catch-all route for debugging */}
                    <Route
                        path="*"
                        element={
                            <div style={{ padding: '50px', textAlign: 'center' }}>
                                <h1>404 - Page Not Found</h1>
                                <p>Path: {window.location.pathname}</p>
                                <button onClick={() => window.location.href = '/'}>Go Home</button>
                            </div>
                        }
                    />
                </Routes>
            </Suspense>
        </>

    );
};

export default LoginRoutes;
